var React = require('react');

function Sr (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#377e3f","d":"M.1 0h640v480H.1z","key":0}),React.createElement("path",{"fill":"#fff","d":"M.1 96h640v288H.1z","key":1}),React.createElement("path",{"fill":"#b40a2d","d":"M.1 144h640v192H.1z","key":2}),React.createElement("path",{"fill":"#ecc81d","d":"M320 153.2l56.4 173.6-147.7-107.3h182.6L263.6 326.8z","key":3})]);
}

Sr.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Sr;

Sr.default = Sr;
